<template>
  <div class="footer">
    <div class="footer_bg">
      <!-- <div class="footer_t">
        <div class="footer_t_m">
          <img src="../../assets/img/logo2.png">
        </div>
      </div> -->
      <div class="footer_b wow fadeInUp" ata-wow-delay="0.2s">
        <div class="footer_b_l">
          <div style="font-size: 16px;">联系电话</div>
          <div style="font-size: 24px;font-weight: bold;">18902339835</div>
          <div>电子邮箱：service@soft0101.cn</div>
          <div>
            广州二进制软件技术有限公司备案号 版权所有 <span style="color: #2870FF ;cursor: pointer;" @click="openUrl">粤ICP备2023147012号</span>
          </div>
        </div>
        <div class="footer_b_r">
          <img src="../../assets/image/ewm.jpg" alt="">
          <div>手机扫一扫添加微信</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBottomNav } from "@/api/index.js";
export default {
  data() {
    return {
      navList: [
        { title: "商务合作", routerPath: "/cooperation" },
        { title: "关于运东", routerPath: "/aboutUs" },
      ],
      footerData: {},
    };
  },
  mounted() {
  },
  methods: {
    openUrl() {
      window.open("https://beian.miit.gov.cn");
    }
  },
};
</script>
<style scoped lang="scss">
$width: 1200px;
.footer {
  width: 100vw;
  height: auto;
  .footer_bg {
    width: 100%;
    height: auto;
    background: #202020;
  }
  &_t {
    width: 100%;
    height: 70px;
    border-bottom: 1px solid rgba($color: #F8F8F8, $alpha: 0.1);
    
    &_m {
      width: $width;
      height: 70px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      img {
        width: 146px;
        height: 38px;
      }
    }
  }
  &_b {
    width: $width;
    height: auto;
    margin: 0 auto;
    padding: 50px 0px;
    box-sizing: border-box;
    color: #CFD3DC;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    &_l {
      .contact_time {
        display: flex;
        column-gap: 50px;
      }
      div {
        margin-bottom: 19px;
      }
    }
    &_r {
      text-align: center;
      color: #CFD3DC;
      font-size: 14px;
      img {
        width: 160px;
        height: 160px;
        margin-bottom: 16px;
      }
    }
  }
}
</style>
